/**
 * Owner direction 2026-10-03: public product pages show only the current
 * product recordings (demo-media manifest). Captures of the older UI and
 * generic stock or AI illustrations are retired from every marketing route.
 * Help-centre articles keep their own screenshots (separate follow-up).
 */
const RETIRED = [
  /\/images\/demo-screenshots\//,
  /\/images\/features\/analytics\//,
  /\/images\/platform\//,
  /\/images\/platform-homepage\//,
  /\/images\/help\/product-story\//,
  /\/images\/help\/ask-caire-panel/,
  /\/images\/optimized\/(caire-AI-hero-1920\.webp|caire-AI\.webp|caire-ai-heart-chip|caire-brain-ai|ai-homecare-preview\.webp|admin-interface)/,
  /\/images\/ai visual inspo\//,
  /\/images\/press\/2[34]_/,
  /\/images\/caire-flywheel-2\.0\.png/,
];

export function isRetiredMedia(src: string | undefined | null): boolean {
  return Boolean(src) && RETIRED.some((pattern) => pattern.test(src!));
}
